'use client';
import { Box } from '@mui/material';
import * as React from 'react';
import { ZipSelectorProps } from './lib/types';
import { ZipInput } from './ui/zip-input';
import { CountySelect } from './ui/county-select';
import { CountyLabel } from './ui/county-label';
import { useEffect, useState } from 'react';
import { getState } from './lib';
import { useCountiesByZipLazyQuery } from '@coverright/data-access/medicare/documents';

export function ZipSelector(props: ZipSelectorProps) {
  const [zip, setZip] = useState(props.zip || '');

  const [requestCounties, { loading, called, data }] = useCountiesByZipLazyQuery();

  const getCounties = async (input: string)=> {
    const res = await requestCounties({ variables: { zip: input } });
    const counties = res.data?.plans_zip_county_fips || [];
    if (counties.length === 1) {
      props.onChange({
        zip: input,
        county: counties[0].countyname,
        state: counties[0].state,
      });
    }
  }

  const counties = zip.length === 5 ? data?.plans_zip_county_fips || [] : [];

  const error =
    zip.length === 5 && !loading && called && !counties.length
      ? "We can't find your county"
      : undefined;

  useEffect(() => {
    if (props.zip?.length === 5) {
      setZip(props.zip);
      getCounties(props.zip);
    }
  }, [props.zip]);

  //----- input handlers -----------

  const handleZipChange = async (value: string) => {
    if (zip.length === 5 && value.length !== 5) {
      props.onChange({ zip: '', county: '', state: '' });
    }
    setZip(value);
    if (value.length === 5) {
      getCounties(value);
    }
  };

  const handleCountySelect = (county: string) => {
    props.onChange({ zip, county, state: getState(county, counties) });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: props.direction || 'column',
        gap: 2,
      }}
    >
      <ZipInput
        onChange={handleZipChange}
        value={zip}
        autoFocus={props.autoFocus}
        error={error || props.errors?.zip}
        label={props.label}
        loading={loading}
        onFocus={props.onFocus}
        onClick={props.onClick}
      />
      <>
        {counties.length === 1 && (
          <CountyLabel
            showLabel={props.direction === 'row' && counties.length <= 1}
            countyname={counties[0].countyname}
            state={counties[0].state}
          />
        )}
        {counties.length > 1 && (
          <CountySelect
            defaultValue={props.county || ''}
            onChange={handleCountySelect}
            loading={loading}
            error={props.errors?.countyName}
            disabled={counties.length < 2 || loading}
            options={counties}
          />
        )}
      </>
    </Box>
  );
}
